<template>
    <div class="relative flex w-full items-center justify-between">
        <div
            v-if="providerActive"
            class="flex items-center justify-between gap-[12px] xs:gap-[24px]"
            @click="isShowSearch ? (isShowSearch = false) : handleBack()"
        >
            <svg
                v-if="isShowSearch"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.6977 11.9998L18.8492 6.84824C19.318 6.37949 19.318 5.62012 18.8492 5.15137C18.3805 4.68262 17.6211 4.68262 17.1523 5.15137L12.0008 10.3029L6.84922 5.15137C6.38047 4.68262 5.62109 4.68262 5.15234 5.15137C4.68359 5.62012 4.68359 6.37949 5.15234 6.84824L10.3039 11.9998L5.15234 17.1514C4.68359 17.6201 4.68359 18.3795 5.15234 18.8482C5.38672 19.0826 5.69375 19.1998 6.00078 19.1998C6.30781 19.1998 6.61484 19.0826 6.84922 18.8482L12.0008 13.6967L17.1523 18.8482C17.3867 19.0826 17.6938 19.1998 18.0008 19.1998C18.3078 19.1998 18.6148 19.0826 18.8492 18.8482C19.318 18.3795 19.318 17.6201 18.8492 17.1514L13.6977 11.9998Z"
                    fill="#787878"
                />
            </svg>

            <svg
                v-else
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.76355 11L8.96657 5.70718L7.57635 4.29297L0 12.0001L7.57635 19.7072L8.96657 18.293L3.7634 13H24.0001V11H3.76355Z"
                    fill="#787878"
                />
            </svg>

            <!-- <span class="text-[14px] font-medium xs:text-[16px]">
                {{
                    providerActive.name
                        ? providerActive.name
                        : providerActive.nameMb
                }}</span
            > -->
        </div>

        <button
            ref="dropDowntriggerEl"
            type="button"
            data-dropdown-toggle="casino-type-dropdown-menu"
            class="flex min-h-[40px] items-center justify-between rounded-[4px] border-[#E6E6E6] px-[10px] font-normal ring-0"
        >
            <div v-if="providerActive" class="mr-1 flex items-center gap-1">
                <img
                    class="icon h-[32px] w-[32px]"
                    :src="`${staticUrl}/assets/icons/casino/provider/${providerActive?.key ? providerActive?.key : 'all'}-active.svg`"
                />
                <span class="text-[18px] font-semibold capitalize text-black">
                    {{
                        providerActive.id
                            ? providerActive.name
                            : $t(providerActive.name)
                    }}
                </span>
            </div>
            <img class="h-5" :src="`${staticUrl}/assets/icons/icon-down.svg`" />
        </button>

        <div
            id="casino-type-dropdown-menu"
            ref="dropDowntargetEl"
            class="shadow-small top-0 z-50 my-4 hidden w-[100%] cursor-pointer list-none divide-y divide-bigg-gray rounded-[4px] bg-white"
        >
            <ClientOnly>
                <ul
                    class="divide-y px-[39px] py-[16px] text-xs font-medium"
                    role="none"
                >
                    <li v-for="item in providerFilter" :key="item">
                        <button
                            class="flex min-h-[40px] items-center gap-2 text-[12px] font-normal capitalize xs:text-sm"
                            role="menuitem"
                            @click="handleaApplyFilter(item)"
                        >
                            <img
                                v-if="item.key !== providerActive?.key"
                                class="icon-dropdown h-[24px] w-[24px]"
                                :class="{ active: partner?.key === item.key }"
                                :src="`/assets/icons/casino/provider/${
                                    item?.key ? item?.key : 'all'
                                }.svg`"
                            />
                            <img
                                v-else
                                class="h-[24px] w-[24px]"
                                :src="`/assets/icons/casino/provider/${providerActive?.key}-active.svg`"
                            />
                            <span
                                class="text-[12px]"
                                :class="{
                                    'font-semibold': partner?.key === item.key,
                                }"
                            >
                                {{ item.name ? item.name : item.nameMb }}
                            </span>
                        </button>
                    </li>
                </ul>
            </ClientOnly>
        </div>

        <div>
            <svg
                class="icon-clear"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="isShowSearch = true"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 10C18 13.866 14.866 17 11 17C7.13401 17 4 13.866 4 10C4 6.13401 7.13401 3 11 3C14.866 3 18 6.13401 18 10ZM16.2973 17.2767C14.8111 18.3605 12.9802 19 11 19C6.02944 19 2 14.9706 2 10C2 5.02944 6.02944 1 11 1C15.9706 1 20 5.02944 20 10C20 12.2691 19.1603 14.342 17.7747 15.925L22.681 20.7876L21.2732 22.2081L16.2973 17.2767Z"
                    fill="#A2A2A2"
                />
            </svg>
            <Transition name="slide-fade">
                <div
                    v-if="isShowSearch"
                    class="input-search absolute h-[44px]"
                    :class="{
                        'input-search--focus': isFocus,
                    }"
                >
                    <input
                        v-model="keyword"
                        :placeholder="$t('common.search')"
                        maxlength="20"
                        class="absolute inset-0"
                        @focus="isFocus = true"
                        @blur="isFocus = false"
                        @keyup.enter="hideMobileKeyboard"
                    />
                    <svg
                        v-if="isHidden && keyword"
                        class="icon-clear absolute right-[50px] top-[50%] z-[9999]"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        @click="keyword = ''"
                    >
                        <path
                            d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259971 4.80025 -0.11622 6.00666 0.115291 7.17054C0.346802 8.33443 0.918247 9.40352 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0891 10.3295 10.3201 10.9888 9.33342C11.6481 8.34672 12 7.18669 12 6C11.9983 4.40922 11.3656 2.88407 10.2408 1.75921C9.11593 0.63436 7.59078 0.0016799 6 0ZM8.17269 7.51961C8.21558 7.5625 8.24959 7.6134 8.2728 7.66943C8.29601 7.72546 8.30795 7.78551 8.30795 7.84615C8.30795 7.9068 8.29601 7.96685 8.2728 8.02287C8.24959 8.0789 8.21558 8.12981 8.17269 8.17269C8.12981 8.21557 8.0789 8.24959 8.02288 8.27279C7.96685 8.296 7.9068 8.30795 7.84616 8.30795C7.78551 8.30795 7.72546 8.296 7.66943 8.27279C7.61341 8.24959 7.5625 8.21557 7.51962 8.17269L6 6.6525L4.48039 8.17269C4.4375 8.21557 4.3866 8.24959 4.33057 8.27279C4.27454 8.296 4.21449 8.30795 4.15385 8.30795C4.0932 8.30795 4.03315 8.296 3.97713 8.27279C3.9211 8.24959 3.87019 8.21557 3.82731 8.17269C3.78443 8.12981 3.75041 8.0789 3.7272 8.02287C3.704 7.96685 3.69205 7.9068 3.69205 7.84615C3.69205 7.78551 3.704 7.72546 3.7272 7.66943C3.75041 7.6134 3.78443 7.5625 3.82731 7.51961L5.3475 6L3.82731 4.48038C3.74071 4.39378 3.69205 4.27632 3.69205 4.15385C3.69205 4.03137 3.74071 3.91391 3.82731 3.82731C3.91391 3.7407 4.03137 3.69205 4.15385 3.69205C4.27632 3.69205 4.39378 3.7407 4.48039 3.82731L6 5.3475L7.51962 3.82731C7.5625 3.78443 7.61341 3.75041 7.66943 3.7272C7.72546 3.70399 7.78551 3.69205 7.84616 3.69205C7.9068 3.69205 7.96685 3.70399 8.02288 3.7272C8.0789 3.75041 8.12981 3.78443 8.17269 3.82731C8.21558 3.87019 8.24959 3.9211 8.2728 3.97712C8.29601 4.03315 8.30795 4.0932 8.30795 4.15385C8.30795 4.21449 8.29601 4.27454 8.2728 4.33057C8.24959 4.38659 8.21558 4.4375 8.17269 4.48038L6.6525 6L8.17269 7.51961Z"
                            fill="#D0D0D0"
                        />
                    </svg>

                    <div class="icon-search">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M18 10C18 13.866 14.866 17 11 17C7.13401 17 4 13.866 4 10C4 6.13401 7.13401 3 11 3C14.866 3 18 6.13401 18 10ZM16.2973 17.2767C14.8111 18.3605 12.9802 19 11 19C6.02944 19 2 14.9706 2 10C2 5.02944 6.02944 1 11 1C15.9706 1 20 5.02944 20 10C20 12.2691 19.1603 14.342 17.7747 15.925L22.681 20.7876L21.2732 22.2081L16.2973 17.2767Z"
                                fill="#A2A2A2"
                            />
                        </svg>
                    </div>
                </div>
            </Transition>
        </div>
    </div>
    <div class="my-[16px] flex gap-[10px] overflow-x-scroll">
        <div
            v-for="(item, index) in filter"
            :key="index"
            class="flex-shrink-0 rounded-[100px] bg-[#EFEFEF] px-[16px] py-[8px] text-[12px] text-[#000000]"
            :class="{
                'bg-[#F7D936]': keyFilter === item.value,
            }"
            @click="keyFilter = item.value"
        >
            {{ $t(item.i18_key) }}
        </div>
    </div>
</template>

<script setup>
import { initDropdowns, Dropdown } from 'flowbite'

const keyFilter = ref('all')
const props = defineProps({
    /* eslint-disable */
    providers: Array,
    redirect: String,
    isSplice: Boolean,
    filter: Array,
    category: Array,
    /* eslint-enable */
})
const isShowSearch = ref(false)
const emit = defineEmits(['onPartnerSelected', 'onChange', 'onChangeFilter'])
const staticUrl = useRuntimeConfig().public.staticUrl
const partner = ref({})
const activeTab = ref('')
const route = useRoute()
activeTab.value = route.query.partner
const providerFilter = computed(() => {
    const data = JSON.parse(JSON.stringify(props.providers))
    return props.isSplice ? data.splice(1) : data
})

const keyword = ref('')
const isHidden = ref(false)
const isFocus = ref(false)

const providerActive = computed(() => {
    return props.providers.find((item) =>
        partner.value
            ? item.key === partner.value.key
            : item.key === activeTab.value
    )
})

const keyword_input = ref(null)
const hideMobileKeyboard = () => {
    keyword_input.value.blur()
}

// const handleChange = () => {
//     emit('onChange', keyword.value)
// }

watch(
    () => route.query.partner,
    (newVal) => {
        activeTab.value = newVal
        window.scrollTo(0, 1)
    }
)
watch(
    () => keyword.value,
    () => {
        emit('onChange', keyword.value)
    }
)

watch(
    () => isFocus.value,
    () => {
        if (!isFocus.value) {
            setTimeout(() => {
                isHidden.value = false
            }, 300)
        } else {
            isHidden.value = true
        }
    }
)

watch(
    () => keyFilter.value,
    () => {
        emit('onChangeFilter', keyFilter.value)
    }
)

const dropDowntargetEl = ref(null)
const dropDowntriggerEl = ref(null)

const handleaApplyFilter = (payload) => {
    // instance options object
    const instanceOptions = {
        id: 'dropdownMenu',
        override: true,
    }
    // options with default values
    const options = {
        placement: 'bottom',
        triggerType: 'click',
        offsetSkidding: 0,
        offsetDistance: 10,
        delay: 300,
        ignoreClickOutsideClass: false,
    }
    const dropdown = new Dropdown(
        dropDowntargetEl.value,
        dropDowntriggerEl.value,
        options,
        instanceOptions
    )
    dropdown.hide()
    partner.value = payload
    emit('onPartnerSelected', partner.value)
    window.scrollTo(0, 1)
}
const handleBack = () => {
    setTimeout(() => {
        window.scrollTo(0, 1)
    })
    useRouter().replace(`${useRoute().path}?partner=`)
}
onMounted(async () => {
    initDropdowns()
    await nextTick(() => {
        partner.value = providerFilter.value.find(
            (item) => item.key === props.activeTab
        )
    })
    window.scrollTo(0, 1)
})
</script>
<style lang="scss" scoped>
.icon-dropdown {
    filter: brightness(0) saturate(100%) invert(66%) sepia(4%) saturate(30%)
        hue-rotate(44deg) brightness(90%) contrast(91%);
    &.active {
        filter: brightness(0) saturate(100%) invert(0%) sepia(89%)
            saturate(7500%) hue-rotate(115deg) brightness(85%) contrast(109%);
    }
}
.input-search {
    z-index: 2;
    left: 58px;
    right: 0;
    top: 0;
    input {
        font-size: 12px;
        border-radius: 6px;
        border: 1px solid #e6e6e6;
        padding: 0 40px 0 16px;
        &::placeholder {
            color: #b4b4b4;
            font-size: 12px;
            font-style: italic;
        }
        &:focus {
            border: 1px solid var(--primary, #f7d936);
        }
    }
    .icon-search {
        position: absolute;
        right: 0;
        z-index: 3;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
    }
    &--focus {
        .icon-search {
            background: #f7d936;
            svg path {
                fill: black;
            }
        }
    }
    .icon-clear {
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}

.slide-fade-enter-active {
    transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
}

.hide-scroll {
    &::-webkit-scrollbar {
        display: none;
    }
}
.active {
    position: relative;
    color: #b01e46;
    border-bottom: 1px solid #b01e46;
}
</style>
